/* Shipping estimates use native cart rates, never fulfillment or invented totals. */
(() => {
 'use strict';
 const abortError=()=>Object.assign(new Error('aborted'),{name:'AbortError'});
 function pause(ms,signal){return new Promise((resolve,reject)=>{
  if(signal?.aborted){reject(abortError());return;}
  const stop=()=>{clearTimeout(timer);reject(abortError());};
  const timer=setTimeout(()=>{signal?.removeEventListener('abort',stop);resolve();},ms);
  signal?.addEventListener('abort',stop,{once:true});
 });}
 const failure=(code,details)=>Object.assign(new Error(code),{code,details});
 function provinces(raw){try{const value=JSON.parse(raw||'[]');return Array.isArray(value)?value.filter(row=>Array.isArray(row)&&typeof row[0]==='string'&&typeof row[1]==='string'):[];}catch{return [];}}
 function formatPrice(price,currency,locale){
  if(!/^(?:\d+)(?:\.\d+)?$/.test(String(price))||!Number.isFinite(Number(price)))throw failure('invalid_response');
  return new Intl.NumberFormat(locale,{style:'currency',currency}).format(Number(price));
 }
 function createClient({cartURL,origin,request,wait=pause,pollLimit=12}){
  const base=new URL(cartURL,origin);if(base.origin!==new URL(origin).origin||base.search||base.hash)throw failure('invalid_route');
  const endpoint=(kind,address)=>{
   const url=new URL(base.pathname.replace(/\/$/,'')+'/'+kind+'.json',origin);
   for(const key of ['country','province','zip'])url.searchParams.set('shipping_address['+key+']',String(address[key]||''));
   return url.pathname+url.search;
  };
  async function query(url,method,signal){
   if(signal?.aborted)throw abortError();
   const response=await request(url,{method,credentials:'same-origin',headers:{Accept:'application/json'},signal});
   let data;try{data=await response.json();}catch{throw failure('invalid_response');}
   if(!response.ok)throw failure('request_failed',data);
   return data;
  }
  return {async calculate(address,{signal}={}){
   await query(endpoint('prepare_shipping_rates',address),'POST',signal);
   for(let index=0;index<pollLimit;index++){
    const result=await query(endpoint('async_shipping_rates',address),'GET',signal);
    if(result!==null){
     if(!Array.isArray(result?.shipping_rates))throw failure('invalid_response');
     return result.shipping_rates.map(rate=>{
      if(typeof rate?.name!=='string'||!/^(?:\d+)(?:\.\d+)?$/.test(String(rate.price))||!Number.isFinite(Number(rate.price)))throw failure('invalid_response');
      return {name:rate.name,price:rate.price};
     });
    }
    if(index+1<pollLimit)await wait(750,signal);
   }
   throw failure('timeout');
  }};
 }
 window.LiotroShipping={createClient,provinces,formatPrice};
 if(typeof document==='undefined'||!window.LiotroLifecycle)return;
 const instances=window.LiotroLifecycle.create({selector:'[data-liotro-shipping]',setup(root){
  const form=root.querySelector('[data-shipping-form]'),country=root.querySelector('[data-shipping-country]'),province=root.querySelector('[data-shipping-province]'),provinceBox=root.querySelector('[data-shipping-province-container]'),zip=root.querySelector('[data-shipping-zip]'),button=root.querySelector('[data-shipping-submit]'),status=root.querySelector('[data-shipping-status]'),list=root.querySelector('[data-shipping-rates]');
  const client=createClient({cartURL:root.dataset.cartUrl,origin:location.origin,request:fetch});
  let version=0,controller=null,disposed=false;
  const text=(key,values)=>window.LiotroText('liotro.shipping.'+key,values);
  function message(value){status.textContent=value;status.hidden=!value;}
  function invalidate(){version++;controller?.abort();controller=null;button.disabled=false;button.removeAttribute('aria-busy');list.replaceChildren();list.hidden=true;message('');}
  function selectDefault(select,value){const match=[...select.options].find(option=>option.value===value||option.textContent===value);if(match)select.value=match.value;}
  function setProvinces(initial=false){
   const rows=provinces(country.selectedOptions[0]?.dataset.provinces);
   province.replaceChildren(...rows.map(([value,label])=>new Option(label,value)));
   provinceBox.hidden=!rows.length;province.disabled=!rows.length;
   if(initial)selectDefault(province,province.dataset.default);
  }
  selectDefault(country,country.dataset.default);setProvinces(true);
  const input=()=>invalidate();
  const change=event=>{if(event.target===country)setProvinces();invalidate();};
  async function submit(event){
   event.preventDefault();invalidate();
   if(!country.value||country.value==='---'){message(text('choose_country'));country.focus();return;}
   const address={country:country.value,province:province.disabled?'':province.value,zip:zip.value.trim()},revision=version;
   controller=new AbortController();button.disabled=true;button.setAttribute('aria-busy','true');message(text('loading'));
   try{
    const rates=await client.calculate(address,{signal:controller.signal});
    if(disposed||revision!==version||!root.isConnected)return;
    const entries=rates.map(rate=>{
     const row=document.createElement('li'),name=document.createElement('span'),price=document.createElement('strong');
     name.textContent=rate.name;price.textContent=formatPrice(rate.price,root.dataset.currency,document.documentElement.lang||'it');row.append(name,price);return row;
    });
    list.replaceChildren(...entries);list.hidden=!rates.length;message(text(rates.length?'ready':'empty'));
   }catch(error){
    if(disposed||revision!==version||error.name==='AbortError')return;
    let detail='';
    if(error.code==='request_failed'&&error.details&&typeof error.details==='object'){
     for(const key of ['country','province','zip']){const items=error.details[key];if(Array.isArray(items))detail+=text(key)+': '+items.filter(value=>typeof value==='string').join(' ')+' ';}
     if(!detail&&typeof error.details.description==='string')detail=error.details.description;
    }
    message(detail.trim()||text(error.code==='timeout'?'timeout':'failed'));
   }finally{if(!disposed&&revision===version){controller=null;button.disabled=false;button.removeAttribute('aria-busy');}}
  }
  form.addEventListener('input',input);form.addEventListener('change',change);form.addEventListener('submit',submit);document.addEventListener('liotro:cart-updated',invalidate);
  return {dispose(){disposed=true;invalidate();form.removeEventListener('input',input);form.removeEventListener('change',change);form.removeEventListener('submit',submit);document.removeEventListener('liotro:cart-updated',invalidate);}};
 }});
 Object.assign(window.LiotroShipping,instances);instances.mount(document);
})();
